module.exports = __webpack_public_path__ + "img/partner-logo.0ad42e96.svg";